export const MEDIA_PICKER = 'MEDIA_PICKER';
export const BACKGROUND_PICKER = 'BACKGROUND_PICKER';
export const MEDIA_SOURCE_FORM = 'MEDIA_SOURCE_FORM';
export const BACKGROUND_FORM = 'BACKGROUND_FORM';
export const MEETING_ENDED = 'MEETING_ENDED';
export const UPLOAD_ERROR_FORM = 'UPLOAD_ERROR_FORM';
export const BACKGROUND_CHOOSER = 'BACKGROUND_CHOOSER';
export const NO_AUDIO_INPUT_ERROR = 'NO_AUDIO_INPUT_ERROR';
export const LOST_REALTIME_SOCKET_CONNECTION =
  'LOST_REALTIME_SOCKET_CONNECTION';
